document.documentElement.classList.remove('no-js');

(function () {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let revealObserver = null;

  function initReveal(scope) {
    const root = scope || document;
    const items = root.querySelectorAll('.reveal, [data-reveal]');

    if (prefersReduced || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }

    items.forEach((el, index) => {
      el.style.transitionDelay = `${Math.min(index * 45, 280)}ms`;
      revealObserver.observe(el);
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        window.requestAnimationFrame(() => el.classList.add('is-visible'));
      }
    });
  }

  function initMagnetic(scope) {
    const root = scope || document;
    root.querySelectorAll('.magnetic').forEach((el) => {
      if (el.dataset.magneticReady) return;
      el.dataset.magneticReady = 'true';
      el.addEventListener('mousemove', (event) => {
        const r = el.getBoundingClientRect();
        el.style.setProperty('--mx', `${event.clientX - r.left}px`);
        el.style.setProperty('--my', `${event.clientY - r.top}px`);
      });
    });
  }

  function initMenu(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-menu-toggle]').forEach((btn) => {
      if (btn.dataset.menuReady) return;
      btn.dataset.menuReady = 'true';
      btn.addEventListener('click', () => document.body.classList.toggle('menu-open'));
    });
  }

  function initAll(scope) {
    initReveal(scope);
    initMagnetic(scope);
    initMenu(scope);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const el = event.target;
    if (el && el.classList) el.classList.add('is-visible');
  });

  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 20);
    const progress = document.querySelector('.scroll-progress');
    if (progress) {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.transform = `scaleX(${max ? window.scrollY / max : 0})`;
    }
  }, { passive: true });
})();
(function(){
  function initAccordion(scope){
    (scope || document).querySelectorAll('[data-accordion]').forEach((wrap)=>{
      if(wrap.dataset.accordionReady) return;
      wrap.dataset.accordionReady='true';
      wrap.querySelectorAll('.accordion-trigger').forEach((btn)=>{
        btn.addEventListener('click',()=>{
          const item=btn.closest('.accordion-item');
          const panel=item.querySelector('.accordion-panel');
          const open=item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.style.maxHeight=open ? panel.scrollHeight + 'px' : '0px';
        });
      });
    });
  }
  function initTabs(scope){
    (scope || document).querySelectorAll('[data-tabs]').forEach((wrap)=>{
      if(wrap.dataset.tabsReady) return;
      wrap.dataset.tabsReady='true';
      const buttons=wrap.querySelectorAll('[data-tab]');
      const panels=wrap.querySelectorAll('[data-panel]');
      buttons.forEach((button)=>button.addEventListener('click',()=>{
        const id=button.dataset.tab;
        buttons.forEach((b)=>b.classList.toggle('is-active',b===button));
        panels.forEach((p)=>p.classList.toggle('is-active',p.dataset.panel===id));
      }));
    });
  }
  function initExtra(scope){initAccordion(scope);initTabs(scope)}
  document.addEventListener('DOMContentLoaded',()=>initExtra(document));
  document.addEventListener('shopify:section:load',(event)=>initExtra(event.target));
})();


(function(){
  function initAxiomLinksAndProductGold(scope){
    const root = scope || document;

    // Do not hijack normal anchor behaviour. This simply repairs links where an overlay has captured the click.
    root.querySelectorAll('a.collection-tile, .shop-pills a, .category-strip a').forEach((link)=>{
      if(link.dataset.collectionLinkReady) return;
      link.dataset.collectionLinkReady = 'true';
      const href = link.getAttribute('href') || link.dataset.href;
      if(href && href !== '#') link.setAttribute('href', href);
      link.addEventListener('keydown', (event)=>{
        if((event.key === 'Enter' || event.key === ' ') && href && href !== '#') window.location.assign(href);
      });
    });

    root.querySelectorAll('.product-card').forEach((card)=>{
      if(card.dataset.goldReady) return;
      card.dataset.goldReady = 'true';
      card.addEventListener('mousemove', (event)=>{
        const r = card.getBoundingClientRect();
        card.style.setProperty('--mx', `${event.clientX - r.left}px`);
        card.style.setProperty('--my', `${event.clientY - r.top}px`);
      });
      card.addEventListener('click', ()=>{
        card.classList.add('is-clicked');
        window.setTimeout(()=>card.classList.remove('is-clicked'), 700);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', ()=>initAxiomLinksAndProductGold(document));
  document.addEventListener('shopify:section:load', (event)=>initAxiomLinksAndProductGold(event.target));
})();


(function(){
  function scrollToProductsFromHash(){
    if(window.location.hash !== '#axiom-products') return;
    const target = document.getElementById('axiom-products');
    if(!target) return;
    window.setTimeout(()=>{
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      target.focus({ preventScroll: true });
    }, 180);
  }

  function initCollectionScrollLinks(scope){
    const root = scope || document;
    root.querySelectorAll('a[href*="#axiom-products"]').forEach((link)=>{
      if(link.dataset.productScrollReady) return;
      link.dataset.productScrollReady = 'true';
      link.addEventListener('click', (event)=>{
        const href = link.getAttribute('href');
        if(!href) return;
        const url = new URL(href, window.location.origin);
        if(url.origin === window.location.origin && url.pathname === window.location.pathname){
          const target = document.getElementById('axiom-products');
          if(target){
            event.preventDefault();
            history.replaceState(null, '', '#axiom-products');
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            target.focus({ preventScroll: true });
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', ()=>{
    initCollectionScrollLinks(document);
    scrollToProductsFromHash();
  });
  document.addEventListener('shopify:section:load', (event)=>initCollectionScrollLinks(event.target));
  window.addEventListener('hashchange', scrollToProductsFromHash);
})();
